<style></style>
<template>
  <div>
    <div
      class="onboarding-modal modal fade"
      id="aggFormaPago"
      role="dialog"
      tabindex="-1"
      style="display: padding-right: 15px"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Salir</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div>
            <div class="onboarding-content" style="padding: 45px 1px">
              <div class="col-12">
                <div class="row">
                  <div class="col-12">
                    <table
                      class="table table-voice table-fixed table-condensed table-hover"
                    >
                      <tbody>
                        <tr
                          class="bg-info text-center"
                          v-for="current in formas_pagos"
                          v-bind:key="current.id"
                        >
                          <td
                            v-if="current.id == form_pago"
                            @click="refreshDefault()"
                            style="font-weight: bold"
                          >
                            {{ current.nombre }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="!form_pago" class="col-12 text-center">
                    <h6 style="font-weight: bold" class="text-success">FORMA DE PAGO</h6>
                  </div>
                  <div
                    style="overflow-y: scroll; max-height: 175px"
                    class="col-12"
                    v-if="!form_pago"
                  >
                    <!-------------------- Tabla de REsultados -------------------->
                    <table
                      class="table table-voice table-fixed table-condensed table-hover"
                    >
                      <thead>
                        <tr>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="current in formas_pagos" v-bind:key="current.id">
                          <td
                            class="text-center"
                            v-bind:class="{
                              'bg-success': current.id == form_pago,
                              'bg-white': form_pago == null,
                            }"
                            @click="select(current)"
                          >
                            <small style="font-weight: bold">
                              {{ current.nombre }}
                            </small>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div v-if="form_pago" class="col-12">
                    <br />
                    <h6 style="font-weight: bold" class="text-success text-center">
                      INFORMACIÓN DE PAGO
                    </h6>
                    <div class="row">
                      <div
                        v-if="form_pago && form_pago != 'CERT' && form_pago != 'NC'"
                        class="col-12"
                      >
                        <label>Total Pago</label>
                        <input
                          v-on:keyup.enter="agregarPago(currentPago)"
                          type="text"
                          v-model="currentPago.total"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago == 'CERT'" class="col-12">
                        <label># Certificado</label>
                        <input
                          type="text"
                          v-model="currentPago.linea_credito"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago && form_pago == 'NC'" class="col-12">
                        <label>Serie Nota</label>
                        <input
                          type="text"
                          v-model="currentPago.nota_serie"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago && form_pago == 'NC'" class="col-12">
                        <label># de Nota</label>
                        <input
                          type="text"
                          v-model="currentPago.nota_numero"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div
                        v-if="
                          form_pago == 'CHEQUE' ||
                          form_pago == 'TARJETA_CREDITO' ||
                          form_pago == 'DEPOSITO'
                        "
                        class="col-12"
                      >
                        <label>Fecha de Vencimiento</label>
                        <input
                          type="date"
                          v-model="currentPago.fecha_vence"
                          class="form-control form-control-sm"
                        />
                      </div>
                      <div
                        v-if="form_pago == 'CHEQUE' || form_pago == 'DEPOSITO'"
                        class="col-12"
                      >
                        <label>Banco</label>
                        <input
                          type="text"
                          v-model="currentPago.banco_referencia"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago == 'DEPOSITO'" class="col-12">
                        <label>No. Boleta</label>
                        <input
                          type="text"
                          v-model="currentPago.numero_cheque"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago == 'CHEQUE'" class="col-12">
                        <label>No. Cheque</label>
                        <input
                          type="text"
                          v-model="currentPago.numero_cheque"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago == 'CHEQUE'" class="col-12">
                        <label>No. Cuenta</label>
                        <input
                          type="text"
                          v-model="currentPago.cuenta_cheque"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago == 'TARJETA_CREDITO'" class="col-12">
                        <label>No. Tarjeta</label>
                        <input
                          type="text"
                          v-model="currentPago.no_tarjeta"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div v-if="form_pago == 'TARJETA_CREDITO'" class="col-12">
                        <label>Emisor de Tarjeta</label>
                        <select
                          class="form-control"
                          v-model="currentPago.emisor_tarjeta"
                          @change="selectTarjeta(currentPago)"
                        >
                          <option value="VISA">VISA</option>
                          <option value="MASTERCARD">MASTERCARD</option>
                          <option value="AMERICAN EXPRESS">AMERICAN EXPRESS</option>
                          <option value="DINNERS CLUB">DINNERS CLUB</option>
                          <option value="OTRO">OTRO</option>
                        </select>
                      </div>
                      <div
                        v-if="form_pago == 'TARJETA_CREDITO' && emisor_tarjeta == 'OTRO'"
                        class="col-12"
                      >
                        <label>¿Especifique?</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="currentPago.emisor_tarjeta"
                        />
                      </div>
                      <div v-if="form_pago == 'TARJETA_CREDITO'" class="col-12">
                        <label>No. Autorización</label>
                        <input
                          v-on:keyup.enter="agregarPago(currentPago)"
                          type="text"
                          v-model="currentPago.autorizacion"
                          class="form-control form-control-sm text-center"
                        />
                      </div>
                      <div class="col-12">
                        <br />
                        <button
                          v-if="form_pago"
                          class="btn btn-md btn-success"
                          style="width: 90%; margin-left: 5%"
                          type="button"
                          @click="agregarPago(currentPago)"
                        >
                          Agregar Pago
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <br />
                    <div class="row">
                      <div class="col-6 text-center" style="font-weight: bold; color:#24b314" >TOTAL PAGADO</div>
                      <div class="col-6 text-center" style="font-weight: bold; color:#24b314" >PEND. DE PAGAR</div>
                      <div class="col-6 text-center" style="font-weight: bold;">Q{{ current.total_pagado.toFixed(2) }}</div>
                      <div class="col-6 text-center" style="font-weight: bold;">Q{{ current.pendiente_pagar.toFixed(2) }}</div>
                    </div>
                    <br>
                  </div>
                  <div  style="border-top: solid 0.1px #d6dbd7" v-if="form_pago || current.cxcpedidoformapago_set" class="col-12">
                    <br />
                    <div class="table-responsive">
                      <h6 style="font-weight: bold" class="text-success text-center">
                        PAGOS AGREGADOS
                      </h6>
                      <!-------------------- Tabla de REsultados -------------------->
                      <table class="table table-lightborder table-hover">
                        <thead>
                          <tr>
                            <th>Forma de Pago</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="data in current.cxcpedidoformapago_set"
                            v-bind:key="data.id"
                            @click="deleteFormaPago(data)"
                          >
                            <td>{{ data.forma_pago }}</td>
                            <td>{{ data.total }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <!-------------------- END - Basic Table -------------------->
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <p
                  v-if="current && current.total_pagado >= current.total"
                  class="text-success text-center"
                  style="font-weight: bold"
                >
                  <u>*Total de Pedido Completado</u>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="current.cxcpedidoformapago_set && current.cxcpedidoformapago_set[0]"
        class="floated-chat-btn"
        @click="facturarPedido(current)"
      >
        
        <span>Facturar</span> &nbsp;
        <i class="fas fa-cash-register"></i>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";
import PedidosServices from "@/services/pos/PedidosServices";

export default {
  components: {},
  data() {
    return {
      currentPago: {},
      form_pago: "",
      emisor_tarjeta: "",
    };
  },
  props: {
    current: {
      type: Object,
    },
    formas_pagos: {
      type: Array,
    },
  },
  watch: {},
  computed: {},
  mounted() {
    let self = this;
  },
  methods: {
    facturarPedido(current) {
      let self = this;
      Notifications.alert.confirm("Facturar Pedido", "¿Esta Seguro?", "", function () {
        DynamicService.postAction("cxc", "pedidos", current.id, "facturar")
          .then((reponse) => {
            Notifications.alert.success("Facturar Pedido", "Realizado Correctamente");
            self.refreshDefault();
            self.$emit("refreshCurrent");
            self.refreshCurrent(self.current);
            $("#aggFormaPago").modal("hide");
          })
          .catch((error) => {
            var errors;
            console.log(error.response.data);
            if (error.response.data.total_pagado) {
              errors = error.response.data.total_pagado;
            }
            Notifications.alert.error("Facturar Pedido", errors);
          });
      });
    },
    deleteFormaPago(data) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar Forma de Pago",
        "¿Esta Seguro?",
        "",
        function () {
          DynamicService.postAction("cxc", "pedidos", self.current.id, "eliminar_pago", {
            id: data.id,
          })
            .then((reponse) => {
              Notifications.alert.success("Eliminar Pago", "Realizado Correctamente");
              self.refreshDefault();
              self.$emit("refreshCurrent");
              self.refreshCurrent(self.current);
            })
            .catch((error) => {
              Notifications.alert.error("Eliminar Pago", error.response.data.detail);
            });
        }
      );
    },
    refreshCurrent(current) {
      let self = this;
      PedidosServices.getById(this.$route.params.id).then((response) => {
        current = response.data;
      });
    },
    agregarPago(currentPago) {
      let self = this;
      self.currentPago.forma_pago = self.form_pago;
      if (self.currentPago.forma_pago != "EFECTIVO") {
        if (self.currentPago.total > self.current.pendiente_pagar) {
          Notifications.alert.error(
            "Agregar Pago",
            "La cantidad a Pagar es mayor a la cantidad total"
          );
          return;
        }
      }
      DynamicService.postAction(
        "cxc",
        "pedidos",
        self.current.id,
        "agregar_pago",
        currentPago
      )
        .then((response) => {
          {
            Notifications.alert.success("Agregar Pago", "¡se ha realizado exitosamente!");
            self.refreshDefault();
            self.$emit("refreshCurrent");
            self.refreshCurrent(self.current);
          }
        })
        .catch((error) => {
          self.error = error.response.data[0];
          Notifications.alert.error("Agregar Pago", self.error);
        });
    },
    selectTarjeta(currentPago) {
      let self = this;
      self.emisor_tarjeta = currentPago.emisor_tarjeta;
    },
    refreshDefault() {
      let self = this;
      self.form_pago = "";
      self.currentPago = {
        total: "",
        fecha_vence: "",
        banco_referencia: "",
        numero_cheque: "",
        cuenta_cheque: "",
        no_tarjeta: "",
        emisor_tarjeta: "",
        autorizacion: "",
        forma_pago: "",
      };
    },
    select(current) {
      let self = this;
      self.refreshDefault();
      if (self.form_pago == current.id) {
        self.form_pago = null;
        return;
      }
      self.form_pago = current.id;
    },
  },
};
</script>
